
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/evastekaytanto",
      function () {
        return require("private-next-pages/[country]/[language]/evastekaytanto/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[country]/[language]/evastekaytanto"])
      });
    }
  